import translator from '@Components/Utilities/Translator';
import AlertPreferences from '@Components/AlertPreferences/AlertPreferences';
import Button from '@mui/material/Button';

const NotificationSettings = (props) => {

    return (
        <>{props.NotificationSubmenus.filter(submenu => submenu.Key == props.activeTab).map(submenu =>
            <div className={props.NewRegistration ? 'registration__container tab-content active' : 'tab-content active'} id="content-5a">
                <div className="notification-header">
                    <h3 className='mobile-hide'>{submenu.Title}</h3>
                    <Button variant='contained' size='small' href={props.WatchListUrl} className='ts-button template-branded-button account-button title'>
                        {translator.translate('sandhills.tradesites.mvc.viewmywatchlist')}
                    </Button>                    
                </div>
                {submenu.showAlerts ?
                    <>
                        <AlertPreferences {...props} IsModal={false} isBidConfirmation={false} />
                    </>
                    :
                    <>
                        <div className="grey-box">
                            <span dangerouslySetInnerHTML={{ __html: submenu.LinkText }}></span>
                        </div>
                    </>
                }
                {props.RedirectURL &&
                    <Button variant='contained' size='small' href={props.RedirectURL} className='ts-button template-branded-button'>
                        {translator.translate('sandhills.tradepubwebsite.mvc.finishregistration')}
                    </Button>
                }
            </div>)
        }</>
    );
};

export default NotificationSettings;